import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    // 防止用户重复点击相同路由报错的拦截请求
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: '/student'
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: '登录'
        },
        component: () => import("../views/login.vue")
    },

    {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue')
    },
    {
        path: '/student',
        name: 'student',
        component: () => import('../views/student/index.vue')
    },
    {
        path: '/grade',
        name: 'grade',
        component: () => import('../views/grade/index.vue')
    },
    {
        path: '/guidance',
        name: 'guidance',
        component: () => import('../views/guidance/index.vue')
    },
    {
        path: '/homeShow',
        name: 'homeShow',
        component: () => import('../views/homeShow/index.vue')
    },
    {
        path: '/performance',
        name: 'performance',
        component: () => import('../views/performance/index.vue')
    },
    {
        path: '/obstacleShow',
        name: 'obstacleShow',
        component: () => import('../views/obstacleShow/index.vue')
    },
    {
        path: '/obstacleGuidance',
        name: 'obstacleGuidance',
        component: () => import('../views/obstacleGuidance/index.vue')
    },
    {
        path: '/obstacle',
        name: 'obstacle',
        component: () => import('../views/obstacle/index.vue')
    },
    {
        path: '/obstacleGrade',
        name: 'obstacleGrade',
        component: () => import('../views/obstacleGrade/index.vue')
    },
    {
        path: '/obperfor',
        name: 'obperfor',
        component: () => import('../views/obperfor/index.vue')
    },
    //  新增量表
    {
        path: '/addScale',
        name: 'addScale',
        component: () => import('@/views/add-scale/index.vue')
    },
    // 量表列表
    {
        path: '/scale',
        name: 'scale',
        component: () => import('@/views/topic-list/index.vue')
    },
    {
        path: '/scaleContent',
        name: 'scaleContent',
        component: () => import('@/views/scale-content/index.vue')
    },
    // 通用测评报告页
    {
        path: '/currencyGrade',
        name: 'currencyGrade',
        component: () => import('@/views/currency-grade/index.vue')
    },





]
const router = new VueRouter({
    mode: "history",
    routes
});


router.beforeEach((to, from, next) => {
    // document.title = `${to.meta.title} | uict_agedcaring`;
    document.title = "量表测评";

    const token = sessionStorage.getItem('token');
    history.pushState(null, null, location.href)
    if (!token && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }


});


export default router

